<template>
  <div>
    <AllOperationsDialogs ref="allOps" @reload="$emit('reload')"/>

    <v-menu bottom offsetX>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="oderon" block>
          Operações
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </template>
      <div class="d-flex">
        <div
          class="d-flex white flex-column pa-3"
          style="width: 300px"
          v-for="group in groups"
          :key="group.text"
        >
          <div class="overline text--disabled px-4 pt-3">{{ group.text }}</div>

          <v-list class="">
            <v-list-item
              v-for="(item, idx) in group.items"
              :key="idx"
              :disabled="item.isDisabled"
              @click="triggerOp(item)"
            >
              <!-- <v-list-item-action v-if="item.icon != null">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action> -->
              <v-list-item-title>
                {{ item.text || item.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import AllOperationsDialogs from './AllOperationsDialogs.vue'

export default {
  components: { AllOperationsDialogs },
  props: {
    clientId: { required: true }
  },
  data() {
    let instalacao = {
      text: 'Instalação',
      items: [
        { text: 'Associar a um veículo...', code: 'Associate' },
        { text: 'Desassociar do veículo...', code: 'Dissociate' },
        // { text: 'Trocar módulo...', isDisabled: true },
        { text: 'Registro de Instalação...', code: 'Install2' },
        { text: 'Registro de Retirada...', code: 'Remove' },
        { text: 'Registro de Intervenção...', code: 'Intervention' }
      ]
    }

    let troubleshooting = {
      text: 'Troubleshooting',
      items: [
        {
          text: 'Identificar/investigar problema...',
          code: 'TroubleshootInvestigate'
        },
        { text: 'Resolver problema...', code: 'TroubleshootSolve' },
        { text: 'Associar ticket...', code: 'AssociateTicket' }
      ]
    }

    let manutencao = {
      text: 'Manutenção',
      items: [
        { text: 'Checklist de verificação...', code: 'VerifyChecklist' },
        { text: 'Dar baixa...', code: 'RegisterLoss' },
        { text: 'Mudar estoque...', code: 'ChangeDepot' }
      ]
    }

    return {
      groups: [instalacao, troubleshooting, manutencao]
    }
  },
  methods: {
    triggerOp(item) {
      this.$refs.allOps.startNew({ code: item.code, clientId: this.clientId })
    }
  }
}
</script>

<style></style>
